import React from "react";

import { updateNotificationSettings } from "services";

import { getLocalKlimVar, useCancelAsyncOnUnmount } from "utils";

import { Col, Icon, Row, Switch, Typography, Message as message } from "components";

export const ProfileNotificationSetting = ({ details, hp, iconName, setLoading, setting, t, userId }) => {
  const signal = useCancelAsyncOnUnmount()();

  const changeNotificationSettings = (v) => {
    updateNotificationSettings({
      token: getLocalKlimVar("token") || userId,
      item: v,
      signal,
    })
      .then(() => {
        message({ content: t("notifications.updated"), icon: "tick" });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return setting === "newsletter" ? (
    <Row>
      <Col>
        <div className="list">
          <Icon iconName={iconName} size="m" className="icon inline" /> {t("notifications.newsletter.title")}
          <Typography variant="paragraph-m">
            {t("notifications.newsletter.description")} <Switch defaultChecked={details.newsletter} onChange={() => changeNotificationSettings(setting)} />
          </Typography>
        </div>
      </Col>
    </Row>
  ) : (
    <Row>
      <Col>
        <Typography variant="paragraph-m" className="list">
          <Icon iconName={iconName} size="m" className="icon inline" /> {t(`notifications.titles.${setting}`)}
        </Typography>
        <div className="list">
          <Typography variant="paragraph-m">
            {t(`notifications.emails.${setting}`)}{" "}
            <Switch defaultChecked={details[`${setting}_email`]} onChange={() => changeNotificationSettings(`${setting}_email`)} />
          </Typography>
        </div>
        {details.push && (
          <div className="list">
            <Typography variant="paragraph-m">
              {t(`notifications.push.${setting}${typeof hp === "boolean" ? (hp ? ".hp" : ".mp") : ""}`)}{" "}
              <Switch defaultChecked={details[`${setting}_push`]} onChange={() => changeNotificationSettings(`${setting}_push`)} />
            </Typography>
          </div>
        )}
      </Col>
    </Row>
  );
};
